namespace GeniuzPOS.AdvPromo {
    export class PsAdvPromoItem2Columns {
        static columnsKey = 'AdvPromo.PsAdvPromoItem2';
    }
}
